export default __webpack_public_path__ + "static/media/Telugu_cf_2.6b08040c.mp3";